// Integration tiles reused by the Header mega-menu.
export const TILES = [
  { alt: 'NetSuite', src: '/images/netsuite.webp', slug: 'netsuite' },
  { alt: 'Brightpearl', src: '/images/brightpearl.webp', slug: 'brightpearl-integration-shopify-order-editing-sync-account-editor' },
  { alt: 'ShipBob', src: '/images/shipbob.webp', slug: 'shipbob' },
  { alt: 'Cin7 Omni', src: '/images/cin7-omni.webp', slug: 'cin7-omni' },
  { alt: 'Shippingbo', src: '/images/shippingbo.webp', slug: 'shippingbo' },
  { alt: 'Shippit', src: '/images/shippit.webp', slug: 'shippit' },
  { alt: 'Shipvine', src: '/images/shipvine.webp', slug: 'shipvine' },
  { alt: 'Starshipit', src: '/images/starshipit.webp', slug: 'starshipit' },
  { alt: 'Fulfilrite', src: '/images/fulfillrite.webp', slug: 'fulfillrite' },
  { alt: 'Apparel21', src: '/images/apparel21.webp', slug: 'apparel21' },
];

export default function Integrations() {
  return (
    <section className="integrations">
      <div className="integrations__container">
        <div className="integrations__head">
          <span className="section-label">Integrations</span>
          <h2 className="section-title">41 partners. One synced stack.</h2>
          <p className="integrations__sub">
            Warehouse, ERP, and shipping partners stay in sync as customers edit their own orders —
            across 3PL, OMS, ERP, and shipping providers.
          </p>
        </div>

        <div className="pipeline">
          <svg
            className="pipeline__svg"
            viewBox="18 34 1410 440"
            role="img"
            aria-label="Orders sync from your Shopify store through Account Editor to your whole ops stack in real time"
          >
            <defs>
              <clipPath id="pipeStoreClip">
                <rect x="34" y="68" width="310" height="316" rx="16" />
              </clipPath>
            </defs>

            <g>
              <path className="pipeline__link" d="M358,224 C 460,224 500,260 570,260" />
              <path className="pipeline__link" d="M358,260 L570,260" />
              <path className="pipeline__link" d="M358,296 C 460,296 500,260 570,260" />
              <path className="pipeline__link" d="M870,260 C 1000,260 1000,88 1040,88" />
              <path className="pipeline__link" d="M870,260 C 1000,260 1000,198 1040,198" />
              <path className="pipeline__link" d="M870,260 C 1000,260 1000,308 1040,308" />
              <path className="pipeline__link" d="M870,260 C 1000,260 1000,418 1040,418" />

              <path className="pipeline__flow" d="M358,224 C 460,224 500,260 570,260" />
              <path className="pipeline__flow pipeline__flow--gold" d="M358,260 L570,260" />
              <path className="pipeline__flow" d="M358,296 C 460,296 500,260 570,260" />
              <path className="pipeline__flow" d="M870,260 C 1000,260 1000,88 1040,88" />
              <path className="pipeline__flow pipeline__flow--gold" d="M870,260 C 1000,260 1000,198 1040,198" />
              <path className="pipeline__flow" d="M870,260 C 1000,260 1000,308 1040,308" />
              <path className="pipeline__flow" d="M870,260 C 1000,260 1000,418 1040,418" />
            </g>

            <g>
              <rect className="pipeline__card" x="24" y="58" width="330" height="404" rx="16" />
              <image
                href="/images/new-project.webp"
                x="34"
                y="68"
                width="310"
                height="316"
                clipPath="url(#pipeStoreClip)"
                preserveAspectRatio="xMidYMid slice"
              />
              <circle cx="60" cy="406" r="6" fill="#34c759" />
              <text className="pipeline__status" x="78" y="412">Store online</text>
              <text className="pipeline__status-sub" x="44" y="440">All systems operational</text>
            </g>

            <g>
              <rect className="pipeline__hub" x="570" y="130" width="300" height="260" rx="16" />
              <image href="/images/icon.webp" x="693" y="156" width="54" height="54" preserveAspectRatio="xMidYMid meet" />
              <text className="pipeline__hub-title" x="720" y="252" textAnchor="middle">ACCOUNT EDITOR</text>
              <text className="pipeline__sub" x="720" y="280" textAnchor="middle">The source of truth for</text>
              <text className="pipeline__sub" x="720" y="299" textAnchor="middle">your customer &amp; order data</text>
              <rect className="pipeline__pill" x="602" y="330" width="236" height="36" rx="18" />
              <circle cx="640" cy="348" r="5" fill="#5a7799" />
              <text className="pipeline__pill-text" x="656" y="353">Real-time sync active</text>
            </g>

            <g>
              <rect className="pipeline__card" x="1040" y="40" width="250" height="96" rx="16" />
              <rect className="pipeline__icon" x="1058" y="62" width="52" height="52" rx="12" />
              <foreignObject x="1058" y="62" width="52" height="52">
                <div xmlns="http://www.w3.org/1999/xhtml" className="pipeline__icon-fo">
                  <i className="ph ph-chart-bar" aria-hidden="true" />
                </div>
              </foreignObject>
              <text className="pipeline__cat" x="1126" y="80">ERP</text>
              <text className="pipeline__cat-desc" x="1126" y="104">Financials &amp; Accounting</text>
              <path className="pipeline__brandlink" d="M1290,88 L1330,88" />
              <rect className="pipeline__chip" x="1330" y="60" width="92" height="56" rx="12" />
              <image href="/images/netsuite.webp" x="1342" y="74" width="68" height="28" preserveAspectRatio="xMidYMid meet" />

              <rect className="pipeline__card" x="1040" y="150" width="250" height="96" rx="16" />
              <rect className="pipeline__icon" x="1058" y="172" width="52" height="52" rx="12" />
              <foreignObject x="1058" y="172" width="52" height="52">
                <div xmlns="http://www.w3.org/1999/xhtml" className="pipeline__icon-fo">
                  <i className="ph ph-clipboard-text" aria-hidden="true" />
                </div>
              </foreignObject>
              <text className="pipeline__cat" x="1126" y="190">OMS</text>
              <text className="pipeline__cat-desc" x="1126" y="214">Order Management</text>
              <path className="pipeline__brandlink" d="M1290,198 L1330,198" />
              <rect className="pipeline__chip" x="1330" y="170" width="92" height="56" rx="12" />
              <image href="/images/brightpearl.webp" x="1342" y="184" width="68" height="28" preserveAspectRatio="xMidYMid meet" />

              <rect className="pipeline__card pipeline__card--hl" x="1040" y="260" width="250" height="96" rx="16" />
              <rect className="pipeline__icon pipeline__icon--gold" x="1058" y="282" width="52" height="52" rx="12" />
              <foreignObject x="1058" y="282" width="52" height="52">
                <div xmlns="http://www.w3.org/1999/xhtml" className="pipeline__icon-fo pipeline__icon-fo--gold">
                  <i className="ph ph-package" aria-hidden="true" />
                </div>
              </foreignObject>
              <text className="pipeline__cat" x="1126" y="300">3PL</text>
              <text className="pipeline__cat-desc" x="1126" y="324">Logistics &amp; Fulfillment</text>
              <path className="pipeline__brandlink" d="M1290,308 L1330,308" />
              <rect className="pipeline__chip" x="1330" y="280" width="92" height="56" rx="12" />
              <image href="/images/shipbob.webp" x="1342" y="294" width="68" height="28" preserveAspectRatio="xMidYMid meet" />

              <rect className="pipeline__card" x="1040" y="370" width="250" height="96" rx="16" />
              <rect className="pipeline__icon" x="1058" y="392" width="52" height="52" rx="12" />
              <foreignObject x="1058" y="392" width="52" height="52">
                <div xmlns="http://www.w3.org/1999/xhtml" className="pipeline__icon-fo">
                  <i className="ph ph-truck" aria-hidden="true" />
                </div>
              </foreignObject>
              <text className="pipeline__cat" x="1126" y="410">SHIPPING</text>
              <text className="pipeline__cat-desc" x="1126" y="434">Carriers &amp; Rates</text>
              <path className="pipeline__brandlink" d="M1290,418 L1330,418" />
              <rect className="pipeline__chip" x="1330" y="390" width="92" height="56" rx="12" />
              <image href="/images/dpd.webp" x="1342" y="404" width="68" height="28" preserveAspectRatio="xMidYMid meet" />
            </g>
          </svg>

          {/* Vertical flow — mobile only (the horizontal SVG is too wide). */}
          <div className="pipeline__vertical" aria-hidden="true">
            <div className="pv__node pv__node--store">
              <img src="/images/new-project.webp" alt="" className="pv__store-img" />
              <span className="pv__store-body">
                <span className="pv__store-status">
                  <span className="pv__dot" /> Store online
                </span>
                <span className="pv__store-sub">All systems operational</span>
              </span>
            </div>

            <span className="pv__arrow"><i className="ph ph-arrow-down" aria-hidden="true" /></span>

            <div className="pv__node pv__node--hub">
              <img src="/images/icon.webp" alt="" className="pv__hub-icon" />
              <strong className="pv__hub-title">Account Editor</strong>
              <span className="pv__hub-sub">The source of truth for your customer &amp; order data</span>
              <span className="pv__pill"><span className="pv__pill-dot" /> Real-time sync active</span>
            </div>

            <span className="pv__arrow"><i className="ph ph-arrow-down" aria-hidden="true" /></span>

            <div className="pv__dests">
              {[
                { icon: 'ph-chart-bar', cat: 'ERP', desc: 'Financials & Accounting', brand: '/images/netsuite.webp' },
                { icon: 'ph-clipboard-text', cat: 'OMS', desc: 'Order Management', brand: '/images/brightpearl.webp' },
                { icon: 'ph-package', cat: '3PL', desc: 'Logistics & Fulfillment', brand: '/images/shipbob.webp', hl: true },
                { icon: 'ph-truck', cat: 'Shipping', desc: 'Carriers & Rates', brand: '/images/dpd.webp' },
              ].map((d) => (
                <div className={`pv__dest${d.hl ? ' pv__dest--hl' : ''}`} key={d.cat}>
                  <span className={`pv__dest-icon${d.hl ? ' pv__dest-icon--gold' : ''}`}>
                    <i className={`ph ${d.icon}`} aria-hidden="true" />
                  </span>
                  <span className="pv__dest-body">
                    <strong className="pv__dest-cat">{d.cat}</strong>
                    <span className="pv__dest-desc">{d.desc}</span>
                  </span>
                  <img src={d.brand} alt="" className="pv__dest-brand" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
